import { render, staticRenderFns } from "./OtherExWarehouseDetail.vue?vue&type=template&id=93b8cd0c&scoped=true&"
import script from "./OtherExWarehouseDetail.vue?vue&type=script&lang=js&"
export * from "./OtherExWarehouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./OtherExWarehouseDetail.vue?vue&type=style&index=0&id=93b8cd0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b8cd0c",
  null
  
)

export default component.exports